import React from 'react';
import Button from "@components/common/button/button";
import * as heroStyle from "./heroSection.module.scss";
import Customers from '@images/homepage/hero/customers.svg';
import {Link} from "gatsby";
import {getRedirectionLink, pushToDataLayer} from "../../../utils/redirectToTryForFree";
import ButtonLink from "../../common/buttonLink/buttonLink";
import Header from "../../common/header/header";
import RatingComponent from "../../common/rating/rating";
import {StaticImage} from "gatsby-plugin-image";
import {useWindowSize} from "../../../context/mediaQueryContext";
import usePageLoaded from "../../../context/usePageLoaded";

function HeroSection() {
  const { width } = useWindowSize();
  const isPageLoaded = usePageLoaded()
  return (
    <section className={heroStyle.homepageHeroContainer}>
      <div className={heroStyle.homepageHeroContainer__hero}>
        <div className={heroStyle.homepageHeroContainer__hero__section}>
          <div className={heroStyle.homepageHeroContainer__hero__section__heroImg}>
            <StaticImage src="../../../images/homepage/hero/hero-img/hero-image.webp" alt="A screenshot of a booking page made with Trafft" loading="eager" width={800} quality={90} fetchpriority="high"/>
          </div>
          <div className={heroStyle.homepageHeroContainer__hero__section__mainText}>
            <h1><span> Free Scheduling Software</span> to Automate Your Business</h1>
            <div className={heroStyle.homepageHeroContainer__hero__section__mainText__description}>
              Display services, schedule, and availability on your free booking page, and let customers book appointments at their convenience 24/7.
            </div>
              <div className={heroStyle.homepageHeroContainer__hero__section__mainText__buttonsAndDescription}>
                <div className={heroStyle.homepageHeroContainer__hero__section__mainText__buttonsAndDescription__buttons}>
                  <ButtonLink
                    href={getRedirectionLink()}
                    onClick={pushToDataLayer}
                    label="Get started for free"
                    target="_blank"
                    extraClass='primary'
                  />
                  <Link to='/demo' className="tag-tracking-capterra">
                    <Button
                      type='outline-secondary'
                      label='Book a demo'
                    />
                  </Link>
                </div>
              </div>
          </div>
        </div>
          <div className={heroStyle.homepageHeroContainer__hero__section__buttonsAndDescriptionResponsive}>
            <div className={heroStyle.homepageHeroContainer__hero__section__buttonsAndDescriptionResponsive__buttons}>
              <ButtonLink
                href={getRedirectionLink()}
                onClick={pushToDataLayer}
                label="Get started for free"
                target="_blank"
                extraClass='primary'
              />
              <Link to='/demo'
                    className={`${heroStyle.homepageHeroContainer__hero__section__buttonsAndDescriptionResponsive__buttons__demoBtn} tag-tracking-capterra`}>
                <Button
                  type='outline-secondary'
                  label='Book a demo'
                />
              </Link>
            </div>
          </div>
      </div>
      <Header/>
      <div className={heroStyle.homepageHeroContainer__ratingWrapper}>
        <RatingComponent
          customersIcon={Customers}
          customerAccColor={width < 1025 && isPageLoaded ? 'white' : 'black'}
          accountsNum={process.env.CREATED_ACCOUNTS_NUMBER}
          title='GLOBAL CUSTOMERS'
          isLight={width > 1024}
          isHomepage={true}
        />
      </div>
    </section>
  )
}

export default HeroSection;
